import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Link,
} from "@mui/material";
import { useLang } from "../context/LangContext";
import locales from "../locales.json";

const InvoiceTable = ({ invoices = [] }) => {
  const { lang } = useLang();
  const { account_page } = locales;

  if (invoices.length === 0) {
    return <Typography>{account_page.no_invoices[lang]}</Typography>;
  }

  return (
    <>
      <Typography
        variant="h6"
        sx={{
          marginTop: 3,
          marginBottom: 1,
          textAlign: { xs: "center", md: "left" },
        }}
      >
        {account_page.invoices_title[lang]}
      </Typography>
      <div style={{ width: "100%", overflowX: "auto" }}>
        <Table size="small" sx={{ minWidth: 400 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>
                {account_page.invoice_id[lang]}
              </TableCell>
              <TableCell sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>
                {account_page.invoice_date[lang]}
              </TableCell>
              <TableCell sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>
                {account_page.invoice_amount[lang]}
              </TableCell>
              <TableCell sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>
                {account_page.invoice_status[lang]}
              </TableCell>
              <TableCell sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>
                {account_page.invoice_pdf[lang]}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoices?.map((invoice) => (
              <TableRow key={invoice.id}>
                <TableCell>{invoice.number || invoice.id}</TableCell>
                <TableCell>
                  {new Date(invoice.created * 1000).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  {(invoice.amount_paid / 100).toFixed(2)} CHF
                </TableCell>
                <TableCell>
                  {invoice.status === "paid" || invoice.status === "open"
                    ? account_page[invoice.status][lang]
                    : invoice.status}
                </TableCell>
                <TableCell>
                  {invoice.invoice_pdf ? (
                    <Link
                      href={invoice.invoice_pdf}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      PDF
                    </Link>
                  ) : (
                    "-"
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
};

export default InvoiceTable;
